// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","417":"experience","485":"publications"}[chunkId] + "." + {"176":"f54929d5","417":"002a554a","485":"8f377b21"}[chunkId] + ".css";
};